import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const filialsAtom = atom({ key: 'filialsAtom', default: [], effects_UNSTABLE: [persistAtom] });